import { ReactComponent as Created } from "./create.svg";
import { ReactComponent as ForceCreated } from "./force-create.svg";
import { ReactComponent as MetadataSet } from "./set-metadata.svg";
import { ReactComponent as MetadataCleared } from "./clear-metadata.svg";
import { ReactComponent as AssetStatusChanged } from "./force-asset-status.svg";
import { ReactComponent as TeamChanged } from "./set-team.svg";
import { ReactComponent as OwnerChanged } from "./transfer-ownership.svg";
import { ReactComponent as Issued } from "./mint.svg";
import { ReactComponent as Burned } from "./burn.svg";
import { ReactComponent as AssetFrozen } from "./freeze-asset.svg";
import { ReactComponent as AssetThawed } from "./thaw-asset.svg";
import { ReactComponent as Destroyed } from "./destroy.svg";

const icons = {
  Created,
  ForceCreated,
  MetadataSet,
  MetadataCleared,
  AssetStatusChanged,
  TeamChanged,
  OwnerChanged,
  Issued,
  Burned,
  AssetFrozen,
  AssetThawed,
  Destroyed,
};

export default icons;
